import { render, staticRenderFns } from "./LwfTdMultiline.vue?vue&type=template&id=7ed3a868&scoped=true&"
import script from "./LwfTdMultiline.vue?vue&type=script&lang=js&"
export * from "./LwfTdMultiline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3a868",
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QTd,QBtn,QAvatar});
